import { render, staticRenderFns } from "./AppChipSelect.vue?vue&type=template&id=686a7bd1"
import script from "./AppChipSelect.vue?vue&type=script&lang=js"
export * from "./AppChipSelect.vue?vue&type=script&lang=js"
import style0 from "./AppChipSelect.vue?vue&type=style&index=0&id=686a7bd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports